var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"pbi",staticStyle:{"max-height":"90vh"},attrs:{"id":"report-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }